import styled from "styled-components/macro";

export const CommentWrapper = styled.div`
  // Base Styles
  color: var(--grey-0);
  box-sizing: border-box;
  background-color: var(--menu-color-fullscreen);
  padding: 15px;
  box-shadow: var(--card-drop-shadow);
  border-radius: 15px;
  width: ${({ isMobile }) => (isMobile ? "270px" : "100%")};
  top: ${({ isMobile }) => (isMobile ? "10%" : "unset")};
  transform: ${({ isMobile }) => (isMobile ? "translateY(-10%)" : "none")};
  max-height: ${({ isMobile }) => (isMobile ? "80%" : "unset")};
  overflow-y: ${({ isMobile }) => (isMobile ? "auto" : "unset")};

  display: ${({ isMobile, isActive }) => (isMobile && !isActive ? "none" : "flex")};
  z-index: ${({ isActive }) => (isActive ? 100 : 1)};
  flex-direction: column;
  gap: 10px;
  position: ${({ isMobile, useAbsolutePosition }) => (isMobile ? "fixed" : useAbsolutePosition ? "absolute" : "relative")};
  box-shadow: var(--card-drop-shadow);
  font-size: ${({ isMobile }) => (isMobile ? "16px" : "14px")};

  &.activeComment {
    box-shadow: var(--card-drop-shadow-active);
    z-index: 100;
    transition: box-shadow 0.2s ease;
  }

  .hover-tip {
    width: fit-content;
  }
`;

export const CommentHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 100%;
`;

export const CommentActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  .icon-button-wrapper {
    color: var(--primary-cta-high-contrast);
  }
`;

export const CommentInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 9px;

  .commentAuthorContainer {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }

  .commentAuthor {
    font-size: 0.875rem;
    font-family: "Inter", sans-serif;
    font-weight: 600;
    letter-spacing: 0.1em;
    line-height: 120%;
    color: var(--grey-1);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .commentTime {
    font-size: 12px;
    color: var(--grey-2);
    flex-shrink: 0;
    line-height: 1.2;
    display: inline-flex;
    align-items: center;
    padding: 0;
  }

  .userIsAuthor {
    font-size: 12px;
    color: var(--grey-2);
    margin-left: -5px;
  }
`;

export const CommentReplies = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-top: 0;
  border-top: 1px solid var(--grey-3);
  margin-top: 4px;
  width: 100%;
`;

export const CommentContent = styled.div`
  font-size: inherit;
  text-align: left;
  font-family: "Inter", sans-serif;
  line-height: 1.5;

  body[data-theme="cauldron"] & {
    color: var(--grey-1);
  }

  .comment-card-edit-input {
    box-sizing: border-box;
    width: 100%;
    padding: 10px;
    border: 1px solid var(--grey-3);
    border-radius: 5px;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 1.5;
    text-align: left;
    resize: none;
    overflow: hidden;
    transition: height 0.2s ease-in-out;
    background-color: var(--menu-color-fullscreen);
    color: var(--grey-0);

    &::placeholder {
      color: var(--grey-2);
    }

    &:focus {
      outline: none;
      border-color: var(--primary-cta-high-contrast);
    }
  }

  .commentEdited {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.2;
    color: var(--grey-2);
  }
`;

export const CollapsedMessage = styled.div`
  &.is-collapsed {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
  }

  &.is-expandable {
    cursor: pointer;
  }
`;
